"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RECOMMENDER_TYPE = exports.ATTRIBUTE_TYPE = void 0;
// @deprecated, replaced by AttributeType
// @deprecated, replaced by ATTRIBUTE_TYPE
const RECOMMENDER_TYPE = exports.RECOMMENDER_TYPE = ['any', 'exact', 'exclude', 'not_relevant'];
const ATTRIBUTE_TYPE = exports.ATTRIBUTE_TYPE = {
  default: 'default',
  // default attributes cannot be deleted
  any: 'any',
  exact: 'exact',
  exclude: 'exclude',
  not_relevant: 'not_relevant'
};